module.exports = __webpack_public_path__ + "static/media/speaker-bg.47229d36.png";